import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const EstadoFinanciado = (isFinanciado?: boolean) => {
  return (
    <div className='tw-w-full tw-flex tw-items-center tw-justify-center tw-h-full'>
      {isFinanciado && (
        <FontAwesomeIcon
          icon={["fal", "circle-check"]}
          className='!tw-text-secondary tw-h-6 tw-w-6'
        />
      )}
    </div>
  )
}
